import React from "react";
import { connect } from "react-redux";

import { Badge  } from "bootstrap-micro";

import IMG_PANEL_ADD from "img/panel-add.png";

import IMG_PANEL from "img/panels/smartloop_mk2.png";
import IMG_PANEL_MMP from "img/panels/multiloop.png";
import IMG_UNKNOWN from "img/panels/unknown.png";

const IMG_PANEL_MAP = {
    SMARTLOOP_MK2: IMG_PANEL,
    MULTILOOP: IMG_PANEL_MMP,
    UNKNOWN: IMG_UNKNOWN
};

import IMG_RELAY_ADD from "img/relay-add.png";
import IMG_RELAY from "img/relay.jpg";
import { selectAllSites, sitesFetch } from "./store/sitesSlice.js";
import { relaysFetch, selectRelays, selectRelaysLoading } from "./store/relaysSlice.js";
import { getNotificationCount } from "./store/notificationsSlice.js";

export class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        }
        this.props.doFetchRelays();
        this.props.doLoadSites().then(() => this.setState({ loading: false }));
    }

    render() {
        return <div className="container">
            <div>
                <h3>Sites</h3>
                <div id="devices">
                    {this.state.loading ? this.renderLoading() : this.renderSites()}
                </div>
                <h3>Relays</h3>
                <div id="relays">
                    {this.props.isRelaysLoading ? this.renderLoading() : this.renderRelays()}
                </div>
            </div>
        </div>
    }

    renderLoading() {
        return <div style={{ margin: "auto", width: "50%", textAlign: "center" }} id="no-devices" className="alert alert-info" role="alert">
            <i className="fa fa-spinner fa-pulse"></i> Loading&nbsp;devices.
        </div>
    }
    renderSites() {
        return <React.Fragment >
            {this.props.sites.map(s => <SiteWidget key={s.hwaddr} site={s} />)}
            < div key="new" className="panel-widget" onClick={() => location.href = "/#/site/add"}>
                <img src={IMG_PANEL_ADD} width="220" height="190" />
                <h5>Add Site</h5>
            </div >
        </React.Fragment >
    }

    renderRelays() {
        return <React.Fragment>
            {this.props.relays.map(p => this.renderRelay(p))}
            <div className="panel-widget" onClick={() => location.href = "/#/relay/add"}>
                <img src={IMG_RELAY_ADD} width="220" height="190" />
                <h5>Add Relay</h5>
            </div>
        </React.Fragment>
    }

    renderRelay(relay) {
        return <div
            key={relay.id}
            className="panel-widget"
            onClick={() => {
                location.href = `/#/relay/${relay.id}`
            }}
        ><img src={IMG_RELAY} width="220" height="190" />
            <h4>{relay.name}</h4>
            <small className="device-status"><strong>{relay.host}</strong>&nbsp;:&nbsp;{relay.port}</small>
        </div>
    }

}
const SiteWidget = connect((state, { site }) => ({
    unreadNotificationsAndEvents: getNotificationCount(site.hwaddr)(state) + site.unreadCount
}))(
    ({ site, unreadNotificationsAndEvents }) => <div
        key={site.hwaddr}
        className="panel-widget"
        onClick={() => {
            console.log("SITE DATA ON CLICK", site);
            if (site.status == "AUTHED") {
                location.hash = `/site/${site.hwaddr}/events`;
            } else {
                location.hash = `/site/reauth/${site.hwaddr}`;
            }
        }}
    ><img src={IMG_PANEL_MAP[site.panelType]} className="panel-widget__icon" />
        <h4>{site.name || site.hwaddr.match(/[0-9a-f]{2}/g).join(":")}&nbsp;{unreadNotificationsAndEvents > 0 ? <Badge>{unreadNotificationsAndEvents}</Badge> : null}</h4>
        {site.status == "AUTHED"
            ?
            <small className="device-status">Authorised</small>
            :
            <small className="device-status">{
                (site.status == "WAITING" ?
                    "Enable panel connection from Network > Cloud or trigger an event on the panel to verify this connection" :
                    "Unauthorised: Click to re-enter key."
                )}</small>
        }
    </div>
);

export default connect((state) => ({
    token: state.auth.claims,
    sites: selectAllSites(state),
    relays: selectRelays(state),
    isRelaysLoading: selectRelaysLoading(state),
}), {
    doLoadSites: sitesFetch,
    doFetchRelays: relaysFetch
})(Dashboard)